import { ContextMenuVisibleChangedEvent, GridApi } from "ag-grid-community";
import { IExecutionRequestCounterParties } from "@/lib/interfaces and Enums/InterfaceExecutionRequestCounterParties";

// AG Grid has no API for which row an open context menu belongs to, so record it on open.
// executionRequestId is set only for OP ER rows, which close on their own ER status.
let openContextMenu: {
  esid: string;
  api: GridApi;
  executionRequestId?: number;
} | null = null;

export function recordOpenContextMenu(
  esid: string | undefined,
  api: GridApi,
  executionRequestId?: number,
) {
  openContextMenu = esid ? { esid, api, executionRequestId } : null;
}

export function clearOpenContextMenu(api: GridApi) {
  if (openContextMenu?.api === api) openContextMenu = null;
}

// Dismissed menus must not be targeted later, hidePopupMenu also closes column menus.
export function clearContextMenuOnHide(event: ContextMenuVisibleChangedEvent) {
  if (!event.visible) clearOpenContextMenu(event.api);
}

// ES, ER and leg tables are separate grids, so close via the api the menu opened on.
function hideOpenContextMenu() {
  if (!openContextMenu) return;
  const { api } = openContextMenu;
  openContextMenu = null;
  if (api.isDestroyed()) return;
  api.hidePopupMenu();
}

export function closeContextMenuForTrade(esid: string) {
  if (!openContextMenu || openContextMenu.esid !== esid) return;
  if (openContextMenu.executionRequestId !== undefined) return;
  hideOpenContextMenu();
}

export function closeContextMenuForERs(esid: string, executionRequestIds: number[]) {
  if (!openContextMenu || openContextMenu.esid !== esid) return;
  if (openContextMenu.executionRequestId === undefined) return;
  if (!executionRequestIds.includes(openContextMenu.executionRequestId)) return;
  hideOpenContextMenu();
}

export function findERsWithStatusChange(
  oldERs: IExecutionRequestCounterParties[] | undefined,
  newERs: IExecutionRequestCounterParties[] | undefined,
): number[] {
  if (!oldERs || !newERs) return [];
  return newERs
    .filter((newER) => {
      const oldER = oldERs.find(
        (er) => er.executionRequestId === newER.executionRequestId,
      );
      return oldER !== undefined && oldER.status !== newER.status;
    })
    .map((er) => er.executionRequestId);
}
